"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepTitle = StepTitle;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _style = _interopRequireDefault(require("./style"));

var _styles = require("@mui/styles");

var _material = require("@mui/material");

var _react2 = require("@emotion/react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function StepTitle({
  title
}) {
  const theme = (0, _styles.useTheme)();
  const classes = (0, _style.default)(theme);
  return (0, _react2.jsx)(_material.Typography, {
    variant: "h6",
    css: classes.title
  }, title);
}

var _default = StepTitle;
exports.default = _default;